/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：380
 */

module.exports = {
  hide: "style_hide__3VlNz",
  "coco-widget-wrapper": "style_coco-widget-wrapper__33O5V",
  "coco-child-widget": "style_coco-child-widget__3p2cR",
  "coco-child-widget-selected": "style_coco-child-widget-selected__3_Q4j",
  "coco-child-widget-full": "style_coco-child-widget-full__3qRu-",
  buttonWidget: "style_buttonWidget__eN_FA",
  inputWrapper: "style_inputWrapper__2Yvnz",
  text: "style_text__3Cvdx"
}
